module.exports = __webpack_public_path__ + "img/14.da28341.png";